import { Box, TextField } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect, useMemo } from 'react';
import { addSumRow, getSumColorClassName, sxSumColorClass } from 'utils/highlightSumColor';
import { columns } from './columns';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import SearchButton from 'components/buttons/SearchButton';
import ClearButton from 'components/buttons/ClearButton';
import { initFilterData, clearFilterData } from './initData';
import { addIdForDataGrid } from 'utils';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';
import { branchApiNm } from 'branch/constant/branchApiNm';
import CheckboxFormControl from 'components/CheckboxFormControl';


const MonthlyCustomerReport = () => {
  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })

  const monthPickerProp = useMemo(() => ({
    openTo: "month",
    views: ["year", "month"],
    disableMaskedInput: true,
    label: "เดือน-ปี",
    inputFormat: "MMMM YYYY",
    value: filterData.SalDte,
    onChange: (newValue) => { setFilterData(o => ({ ...o, SalDte: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 200 }} />,

  }), [filterData.SalDte])

  const modDataTable = useMemo(() => {
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["NumJo", "DrvFixCost", "TripAmnt", "CostAmnt", "OprTotal", "InvOwnRcptAmnt", "InvCusRcptAmnt"
        , "InvTotal", "Profit"],
      sumColTotal: "CusSNm"
    })
  }, [dataTable])

  const getData = useCallback((filter) => {
    /**
     * The query calculate form DrvId and TukId in job_order table
     * this can be some lost of data Example นาย กิตติพงษ์ จุกแก้ว SalDte: 2024-10-01 JobOrdId 1562 
     * There was 2 people involve but the DrvId in JobOrd is other so total count of this month might not same as 8.5 dialog
     * 
     * Another example นาย ศราวุฒิ ยอยเงิน SalDte: 2024-10-01 in 8.5 there was 8 row 1 row JobOrder not his DrvId 
     * 1 row JobOrder not his main TukId so his salary devide by 7 but TukRow only 6 so multiply by 6
     */
    const postData = {
      ...filter,
      SalDte: filter.SalDte.format("YYYY-MM-01"),
    }
    ax.post(branchApiNm.getMonthlyCustomerReport, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "CusId"))
      }
    })
  }, [ax])

  // const handleCellClick = useCallback((params) => {
  //   if (params.field === 'ShowDetail') {
  //     selectedId = params.id
  //     setDialogOpen(true)
  //   }
  // }, [])

  // const handleRowDoubleClick = useCallback((params) => {
  //   selectedId = params.id
  //   setDialogOpen(true)
  // }, [])

  useEffect(() => {
    getData({ ...initFilterData })
  }, [getData])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <Box flex={1} />
        <CheckboxFormControl label="เฉพาะแจ้งหนี้แล้ว" checked={filterData.IsHasInvId === 1 ? true : false}
          onChange={(e) => setFilterData(o => ({ ...o, IsHasInvId: e.target.checked ? 1 : 0 }))} />
        <DesktopDatePicker {...monthPickerProp} />
        <SearchButton onClick={(() => getData(filterData))} />
        <ClearButton onClick={(() => setFilterData({ ...clearFilterData }))} />
      </BoxFR>
      <Box height='100%' sx={sxSumColorClass}>
        <DataGridCellExpand
          hideFooter
          rows={modDataTable}
          columns={columns}
          // onRowDoubleClick={handleRowDoubleClick}
          // onCellClick={handleCellClick}
          experimentalFeatures={{ rowPinning: true }}
          pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
          getRowClassName={getSumColorClassName}
        />
      </Box>
    </BoxFC>
  );
}

export default MonthlyCustomerReport